// extracted by mini-css-extract-plugin
export default {"inputBox":"MyInput_inputBox__KYd5c"};